import { useCallback, useEffect, useState } from "react";
import { CalendarCheck, CheckCircle2, Loader2 } from "lucide-react";
import { api, errorText, wibTime } from "../lib/api";

/** Athletes must check in (Hadir) for a session today before scoring / jurnal. Coaches & admins pass straight through. */
export function useCheckin(user) {
  const athlete = user?.role === "athlete";
  const [st, setSt] = useState(athlete ? null : { checked_in: true, required: false });
  const reload = useCallback(() => (athlete ? api.get("/training/checkin-status").then((r) => setSt(r.data)).catch(() => setSt({ checked_in: false, required: true, error: true })) : Promise.resolve()), [athlete]);
  useEffect(() => { reload(); }, [reload]);
  return [st, reload];
}

export function CheckinGate({ user, onGoAbsensi, children, compact = false }) {
  const [st, reload] = useCheckin(user);
  const [busy, setBusy] = useState(false); const [err, setErr] = useState("");
  if (user?.role !== "athlete") return children;
  if (!st) return <p className="muted checkin-wait" data-testid="checkin-loading"><Loader2 size={15} className="spin" /> Memeriksa absensi hari ini...</p>;
  if (st.checked_in) return children;
  const now = async () => { setBusy(true); setErr(""); try { await api.post("/training/checkin"); await reload(); } catch (e) { setErr(errorText(e)); } finally { setBusy(false); } };
  return <div className={`checkin-gate ${compact ? "compact" : ""}`} data-testid="checkin-gate">
    <CalendarCheck size={28} />
    <h3>Absen dulu sebelum scoring</h3>
    <p>Skor latihan hanya bisa diisi setelah kamu absen <b>Hadir</b> di sesi hari ini. Waktu absen tercatat otomatis.</p>
    <div className="checkin-actions">
      <button className="yellow-btn" onClick={now} disabled={busy} data-testid="checkin-now">{busy ? <Loader2 size={16} className="spin" /> : <CheckCircle2 size={16} />} Hadir sekarang</button>
      {onGoAbsensi && <button className="outline-btn" onClick={onGoAbsensi} data-testid="checkin-go-absensi">Buka halaman Absensi</button>}
    </div>
    {err && <p className="form-error">{err}</p>}
  </div>;
}

/** Athlete "Absen hari ini" card at the top of the Absensi tab. */
export function TodayCheckin({ user, sessions, onDone }) {
  const [busy, setBusy] = useState(false); const [err, setErr] = useState("");
  if (user?.role !== "athlete" || !sessions) return null;
  const today = new Date(Date.now() + 7 * 3600e3).toISOString().slice(0, 10);
  const mine = sessions.filter((s) => s.date === today).flatMap((s) => (s.mine || []).map((m) => ({ ...m, s })));
  const hadir = mine.find((m) => m.status === "Hadir");
  const go = async () => { setBusy(true); setErr(""); try { await api.post("/training/checkin"); await onDone(); } catch (e) { setErr(errorText(e)); } finally { setBusy(false); } };
  return <div className={`today-checkin ${hadir ? "done" : ""}`} data-testid="today-checkin">
    {hadir ? <><CheckCircle2 size={22} /><div><strong>Kamu sudah absen hari ini</strong><small data-testid="today-checkin-time">Hadir · {hadir.s.title} · pukul {wibTime(hadir.checked_in_at || hadir.updated_at)} WIB</small></div></>
      : <><CalendarCheck size={22} /><div><strong>Absen hari ini</strong><small>{mine.length ? `Status: ${mine[0].status}. ` : ""}Tekan Hadir saat tiba di latihan. Scoring terbuka setelah absen.</small></div><button className="yellow-btn" onClick={go} disabled={busy} data-testid="today-checkin-button">{busy ? "Menyimpan..." : "Hadir sekarang"}</button></>}
    {err && <p className="form-error">{err}</p>}
  </div>;
}
